import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "animate.css";
import Rutas from './rutas.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Rutas />
  </React.StrictMode>
);


